import { ReactComponent as XIcon } from "./icons/x.svg";

import styles from "./ClearFilters.module.scss";
import { therapistListingService } from "services/therapistListingService";

export const ClearFilters = () => {
  return (
    <button
      className={styles.root}
      onClick={() => therapistListingService.clearFilters()}
    >
      <XIcon className={styles.icon} />
      <span className={styles.text}>Clear all</span>
    </button>
  );
};
